import { UseQueryOptions, useQuery } from '@tanstack/react-query';
import { PageResponse } from '@models/api';
import { GetStocksParams, StockResponse, getStocks } from '@apis/stock';
import { dropEmptyValues } from '../../utils/common';

const PAGE_SIZE = 50;

export const useStockList = ({
  page,
  searchParam,
}: {
  page: number;
  searchParam: GetStocksParams;
}) => {
  /**
   * IMPORTANT:
   * React Query cache keys must include all inputs that affect the fetched result.
   * Otherwise, changing filters may not trigger a refetch (often visible on mobile).
   *
   * We key by the "effective" request params (after dropping empty values)
   * so that the cache aligns with the actual API request.
   */
  const cleanedSearch = dropEmptyValues(searchParam, [
    'stockCode',
    'stockName',
    'regionId',
    'supplierId',
    'status',
    'ordering',
  ]);

  const queryOptions: UseQueryOptions<PageResponse<StockResponse>, Error> = {
    queryKey: ['stocks', page, cleanedSearch],
    queryFn: () => {
      return getStocks({
        pageNo: page,
        pageSize: PAGE_SIZE,
        ...cleanedSearch,
      });
    },
    refetchOnMount: 'always',
  };

  return useQuery(queryOptions);
};
